export const MONTAGE = 'Montage';
export const DEMONTAGE = 'Demontage';
export const AUCUN = 'Aucun';
export const IMPRESSION_AFFICHE = 'ImpressionAffiche';
export const FABRICATION_DISPOSITIF = 'FabricationDispositif';
export const DISPOSITIF_FABRIQUE = 'PoseDispositifFabrique';

export const LISTE_ACTION_INTERVENTION = [
  { code: AUCUN, libelle: 'listeTypeOt.actionIntervention.aucun' },
  { code: MONTAGE, libelle: 'listeTypeOt.actionIntervention.montage' },
  { code: DEMONTAGE, libelle: 'listeTypeOt.actionIntervention.demontage' },
];
export const LISTE_ACTION_INTERVENTION_DISPOSITF = [
  { code: FABRICATION_DISPOSITIF, libelle: 'listeTypeOt.actionIntervention.fabricationDipositif' },
  { code: DISPOSITIF_FABRIQUE, libelle: 'listeTypeOt.actionIntervention.poseDispositifFabrique' },
];

export const LISTE_ACTION_INTERVENTION_IPRESSIONAFFICHE = [
  { code: IMPRESSION_AFFICHE, libelle: 'listeTypeOt.actionIntervention.impressionAffiche' },
];
